type DictationInputProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

/** 書き起こしの元になる文の入力欄。マイクの認識結果もキーボード入力もここに入る */
export const DictationInput = ({
  value,
  onChange,
  disabled = false,
}: DictationInputProps) => (
  <textarea
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/\r?\n/g, " "))}
    disabled={disabled}
    rows={3}
    aria-label="書き起こす文"
    className="w-full rounded-xl border border-neutral-300 bg-white p-3 text-base leading-relaxed disabled:opacity-60"
  />
);
